/**
 * スクロール中検知
 */

export module NisseiIsScrollingModule {
  export class Service {
    private static BODY: Element = document.getElementsByTagName('body')[0];

    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.scrollingAction();
      });
    }

    public static scrollingAction() {
      var $timeoutId: number | null = null;
      window.addEventListener("scroll", function () {
        if (!Service.BODY.classList.contains('isScrolling')) {
          Service.BODY.classList.add('isScrolling');
        }

        if ($timeoutId) {
          clearTimeout($timeoutId);
        }

        $timeoutId = window.setTimeout(function () {
          if (Service.BODY.classList.contains('isScrolling')) {
            Service.BODY.classList.remove('isScrolling');
          }
        }, 200);
      });
    }
  }
}
